import React, { Component } from "react";
import { EditHeadComponent } from "../BioAndSubEditComponent";
import { connect } from "react-redux";
import { Container, Row, Col, Button } from "react-bootstrap";
import { TutorSettingAction } from "./../../../redux/actions";
import { updateTutorSettings } from "../../../apis/tutors";
import warning from "../../../assets/icons/warning.png";


class HourlyRateSetting extends Component {
	constructor() {

		super();

		this.state = {
			error: false,
			onFocushourlyRate: "",
			tutorSettingDataState: {},
			disablebutton:'',
		};
		
	}
	
	componentDidMount = () => {
		const { tutorSettingData } = this.props;
		let { tutorSettingDataState } = this.state;
		tutorSettingDataState = { ...tutorSettingData };
		this.setState({
		tutorSettingDataState,
		});
	};
	componentDidUpdate = (prevProps) => {
		const { tutorSettingData } = this.props;
		let { tutorSettingDataState } = this.state;
		if (
		(!tutorSettingDataState?.userId && tutorSettingData?.userId) ||
		prevProps?.tutorSettingData?.userId !== tutorSettingData?.userId
		) {
		tutorSettingDataState = { ...tutorSettingData };
		this.setState({
			tutorSettingDataState,
		});
		}
	};
	onCancel = () => {
		const { tutorSettingData } = this.props;
		this.setState({
		tutorSettingDataState: { ...tutorSettingData },
		});
		this.props.history.push("/tutor-dashboard/TutorSettingBioAndSub");
	};
	onSave = (index) => {
		let { tutorSettingDataState, } = this.state;
		this.props.TutorSettingStoreData(tutorSettingDataState);
		let updateSettingParam = {
		updateSetting: {
			hourlyRate: tutorSettingDataState?.tutorDetails?.hourlyRate,
		},
		};
		updateTutorSettings(updateSettingParam)
		.then((res) => {
		this.setState({
			loader: false,
		});
		this.props.history.push("/tutor-dashboard/TutorSettingBioAndSub");
		})
		.catch((err) => {
			console.log(err);
			this.setState({
			loader: false,
			});
		});
	};

	render() {
		const { tutorSettingDataState, onFocushourlyRate, error } = this.state;
		let hourlyRate = tutorSettingDataState?.tutorDetails?.hourlyRate
			? tutorSettingDataState?.tutorDetails?.hourlyRate : "";

		let color, borderColor, backgroundColor;

		if (onFocushourlyRate) {
			color = "";
			borderColor = "#2cb46d";
			backgroundColor = "";
		} else if (error && parseInt(hourlyRate) < 15) {
			color = "#fa4a4a";
			borderColor = "#fa4a4a";
			backgroundColor = "#fff1f1";
		} else {
			color = "";
			borderColor = "";
			backgroundColor = "";
		}
		
		let warningError = (
			<img
			src={warning}
			alt="warning"
			width="14px"
			height="14px"
			style={{ marginRight: "6px" }}
			/>
		);

		return (
			<Container>
				<Row className="flex-center-center">
					<Col lg={8} md={9} sm={10} xs={11} className="ProfileBio-of-setting-div">
						<EditHeadComponent
							isBorder={false}
							settingTitle={"Set your hourly rate"}
							backToprofileView={ () => this.props.history.push("/tutor-dashboard/TutorSettingBioAndSub") }
							settingDescription={"This hourly rate you set for your lesson is entirely up to you. Askademia will deduct a 20% service fee from the hourly rate you set."}
						/>
						<div>

							<label className="label">Hourly rate</label>
							<div
								tabIndex="-1"
								className="comp_input"
								onBlur={ () => this.setState({ onFocushourlyRate: false }) }
								onFocus={ () => this.setState({ onFocushourlyRate: true }) }
								style={{ color: color, borderColor: borderColor, backgroundColor: backgroundColor }}
							>
								<span
									className="GBP"
									onBlur={ () => this.setState({ onFocushourlyRate: false }) }
									onFocus={ () => this.setState({ onFocushourlyRate: true }) }
									style={{
										color: onFocushourlyRate ? "#2cb46d" : color,
										borderColor: borderColor,
										backgroundColor: backgroundColor,
									}}
								>
									GBP
								</span>
								<input
									type="number"
									name="Your rate"
									placeholder="0.00"
									value={hourlyRate}
									className="form-control"
									onBlur={() => this.setState({ onFocushourlyRate: false })}
									onFocus={() => this.setState({ onFocushourlyRate: true })}
									style={{
										color: color,
										borderColor: borderColor,
										backgroundColor: backgroundColor,
									}}
									onChange={(e) => {
										if (tutorSettingDataState.tutorDetails) {
											if (tutorSettingDataState.tutorDetails.hourlyRate) {
												tutorSettingDataState.tutorDetails.hourlyRate = Number(
													e.target.value
												);
											}
											else {
												tutorSettingDataState.tutorDetails.hourlyRate = "";
												tutorSettingDataState.tutorDetails.hourlyRate = Number(
													e.target.value
												);
											}
										}
										else {
											tutorSettingDataState.tutorDetails = {};
											tutorSettingDataState.tutorDetails.hourlyRate = ""
											tutorSettingDataState.tutorDetails.hourlyRate = Number(
											e.target.value
											);
										}
										this.setState({ tutorSettingDataState});
									}}
								/>
							</div>
							{ 
								error && parseInt(hourlyRate) < 15 ? (
									<div className="error">
										{ warningError }Your hourly rate must be at least £15
									</div>
								) : ""
							}

							<label className="label">Service fee</label>
							<div className="comp_input">
								<span className="GBP">GBP</span>
								<input
									disabled
									type="number"
									name="serviceFee"
									placeholder="0.00"
									className="form-control"
									value={ (hourlyRate * 20) / 100 !== 0 ? (hourlyRate * 20) / 100 : "" }
								/>
							</div>

							<label className="label">You earn</label>
							<div className="comp_input">
								<span className="GBP">GBP</span>
								<input
									disabled
									type="number"
									name="youEarn"
									placeholder="0.00"
									className="form-control"
									value={ (hourlyRate * 80) / 100 !== 0 ? (hourlyRate * 80) / 100 : "" }
								/>
							</div>
							<button
								className="save"
								onClick={
									parseInt(hourlyRate) < 15 ? () => this.setState({ error: true })
										: this.onSave
								}
								disabled={
									hourlyRate.length < 1 || (error && parseInt(hourlyRate) < 15)
										? true : false
								}
							>
								Save
							</button>
							<button className="cancel" onClick={this.onCancel}>Cancel</button>				
						</div>
					</Col>
				</Row>
			</Container>
		);
	}

}

const mapDispatchToprops = (dispatch) => {
  return {
    TutorSettingStoreData: (payload) =>
      dispatch(TutorSettingAction.TutorSettingStoreData(payload)),
  };
};

const mapStateToProps = (state) => {
  const {
    TutorSettingReducer: { tutorSettingData },
  } = state;
  return {
    tutorSettingData,
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(HourlyRateSetting);
